import { Badge } from '@/components/ui/badge';
import type { FlagReason } from '@/lib/daily-reports/types';
import { useFlagReasonLabel } from './dailyReportLabels';

export function ReasonChips({ reasons }: { reasons: FlagReason[] }) {
  const flagLabel = useFlagReasonLabel();
  return (
    <div className="flex flex-wrap gap-1">
      {reasons.map((reason) => (
        <Badge key={`${reason.id}-${reason.column}`} variant="destructive">
          {flagLabel(reason.id)}
          {reason.value !== '' ? ` ${reason.value}` : ''}
        </Badge>
      ))}
    </div>
  );
}
